import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../../app/guards'
import { taxRatesQueryOptions } from '../../../../features/finance/queries'
import { EditCreditNotePage } from '../../../../features/sales/credit-note-pages'
import { salesSettingsQueryOptions } from '../../../../features/sales/queries'

export const Route = createFileRoute('/_app/credit-notes/$creditNoteId/edit')({
  staticData: { crumb: 'creditNoteEdit' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'creditNotes.create'),
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(salesSettingsQueryOptions),
      context.queryClient.ensureQueryData(taxRatesQueryOptions),
    ])
  },
  component: EditCreditNotePage,
})
